export default "__VITE_ASSET__B5HxiVu7__"